module.exports = __webpack_public_path__ + "static/media/messenger_2x.68ce35e8.png";